import * as core from '../../../../../../../core'

import { query } from './projects-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.award-details.widgets.projects-table',
    description: 'Award Projects',
    name: 'Award Projects',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
